"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactFinalForm = require("react-final-form");

var _Mentions = _interopRequireDefault(require("../../form/inputs/Mentions"));

var _form = require("../../form");

var _mentionInputStyle = require("../../styles/mentionInputStyle");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function CommentTextarea(_ref) {
  var name = _ref.name,
      validate = _ref.validate,
      rows = _ref.rows,
      placeholder = _ref.placeholder,
      value = _ref.value,
      users = _ref.users;

  function Input(_ref2) {
    var input = _ref2.input,
        meta = _ref2.meta;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_form.ErrorWrapper, {
      touched: meta.touched,
      error: meta.error
    }, /*#__PURE__*/_react.default.createElement(_Mentions.default, _extends({}, input, {
      style: _mentionInputStyle.replyFormStyle,
      users: users,
      name: name,
      rows: rows,
      resize: "false",
      autoFocus: true,
      placeholder: placeholder
    }))));
  }

  return /*#__PURE__*/_react.default.createElement(_reactFinalForm.Field, {
    initialValue: value,
    name: name,
    render: Input,
    validate: validate
  });
}

CommentTextarea.defaultProps = {
  rows: 3,
  validate: function validate() {}
};
CommentTextarea.propTypes = {
  name: _propTypes.default.string.isRequired,
  validate: _propTypes.default.func,
  rows: _propTypes.default.number
};
var _default = CommentTextarea;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@contently/toolkit/dist/comments/Comment/CommentTextarea.js
// module id = 814
// module chunks = 0 15 16 17 18